export default __webpack_public_path__ + "static/media/edr-interface.55eba7ca.png";